import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title, Meta, SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';

import { of, from, throwError, timer, Observable, interval, Subscription } from 'rxjs';
import { map, retry, retryWhen, take, takeWhile, tap, delay, concatMap, mergeMap, catchError } from 'rxjs/operators';

import { Playlist } from 'src/app/models/playlist';
import { Video } from 'src/app/models/video';
import { Trigger } from 'src/app/models/trigger';
import { Chapter } from 'src/app/models/chapter';
import { CtaSimple, CtaShowType } from 'src/app/models/cta-simple';
import { Question } from 'src/app/models/question';
import { MessageSimple } from 'src/app/models/message-simple';
import { FormOverlay } from 'src/app/models/form-overlay';
import { FormExpand } from 'src/app/models/form-expand';
import { BaseService } from 'src/app/services/base.service';
import { GaService } from 'src/app/services/ga.service';
import { PlayerHelper } from 'src/app/helpers/player-helper';
import { CtaSimpleExpandComponent } from 'src/app/components/oneroll-player/cta-simple/cta-simple-expand/cta-simple-expand.component';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

  CtaShowType = CtaShowType;

  @Input() playlist:Playlist;
  @Input() video:Video;
  @Input() lp: boolean = false;
  @Output() formExpandInputed:EventEmitter<FormExpand> = new EventEmitter();

  responsible: boolean;

  player:any;
  style:SafeHtml;
  playerHelper:PlayerHelper;

  playerHeight:string = "100%";

  // 各1再生につき固有のID
  // Playlist内で再生されるVideoには、track-client-local-storage内で生成される
  // viewHash（これはplaylistのviewHashとして利用される）ではなくここで生成したvideoViewHashを使う
  videoViewHash:string;

  duration:number;

  isEnablePlayKeyEvent:boolean = true;

  playerRootElement:HTMLElement;
  playerContainer:HTMLElement;
  position:number;  // 現在の再生位置
  maxPosition:number = 0; // 再生中に最大となった再生位置
  chapters:Array<Chapter> = [];
  sliderChaptersElement: HTMLElement;
  sliderChapterElements: any;

  // onTimeが実行されると指定した回数の割合だけ実行されない
  // 例 2の場合、onTimeが2回呼び出されたらそのうちの1回だけ処理を実行する
  onTimeEventRate:number = 2;
  onTimeEventCounter:number = null;

  history:Array<any>;
  prevPosition:number;
  viewState:number; // 0(min) -> 1(max),
  watchtimeTriggeredTimes:number;
  watchtimeTriggerInterval:number;
  isPassed0Seconds:boolean;
  // isPassed1Seconds:boolean;
  // isPassed2Seconds:boolean;
  isPassed3Seconds:boolean;
  isPassed10Seconds:boolean;

  // GoogleAnalytics用
  isPassed0Percent:boolean;
  isPassed2Percent:boolean;
  isPassed5Percent:boolean;
  isPassed10Percent:boolean;
  isPassed25Percent:boolean;
  isPassed50Percent:boolean;
  isPassed75Percent:boolean;
  isPassed95Percent:boolean;

  isTriggered = false;

  showLiveThumbnail:boolean = false;
  liveStatus: "none" | "before-start" | "live" | "after-end" = "none";
  liveStartSubcription: Subscription;

  // 各1再生につき固有のID
  // video tag history用のviewHash
  videoTagViewHash:string = null;

  @Output() playerTriggered = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) public document: any,
    private titleService:Title,
    private metaService:Meta,
    private domSanitizer: DomSanitizer,
    public platform: Platform,
    public baseService: BaseService,
    private gaService: GaService,
  ) { }

  // 収録型ライブの場合はまずクリックしてスタートする形になる
  // ・再生アイコン付きサムネイルが表示される
  // ・サムネイルをクリックしたら再生前案内画面へ遷移
  // ・そのクリックイベントからすべての動作を始める



  // Liveの場合、クリックイベントを元にスタート
  liveThumbnailClicked(event){
    console.log("liveThumbnailClicked");
    this.showLiveThumbnail = false;
    const liveStart = this.checkStartLive();
    if(liveStart){
      return;
    }

    // 現在時刻
    const currentTime = Math.floor((new Date()).getTime() / 1000);

    // 開始時刻からの差分
    const diffTimeFromStart = currentTime - this.video.userVideo.live.start;
    this.checkTrigger(diffTimeFromStart);
  }

  ngOnInit() {
    // 通常配信と収録型ライブで分ける

    // 通常配信
    // →今まで通り


    // 収録方ライブ
    // →開始前案内の場合
    //   → サムネイルクリックイベント内で、開始前案内を表示
    // →ライブ中の場合
    //   → 今まで通り
    // →終了後案内の場合
    //   → 今まで通り







    // JWPlayerのmute設定があれば削除（過去の設定が残ってしまうため、特にライブ配信開始時に影響するため削除しておく）
    // localStorage.removeItem("jwplayer.mute");

    const responsible = document.getElementById("html-root") ? document.getElementById("html-root").classList.contains("responsible") : null;
    if(responsible){
      this.responsible = true;
      this.playerHeight = "auto";
    }

    this.titleService.setTitle(this.video.userVideo.title);

    let description;
    if(this.video.userVideo.description){
      description = this.video.userVideo.description;
    }
    else{
      description = this.video.userVideo.title;      
    }
    this.metaService.addTag({ name: 'description', content: description });

    setTimeout(() => {
      this.playerRootElement = this.document.getElementById("player-root");
      if(this.video.userVideo.formExpand){
        this.playerHeight = this.playerRootElement.getBoundingClientRect().width * 9 / 16 + "px";
      }

      if(this.video.userVideo.live){
        this.showLiveThumbnail = true;
        const height = document.getElementById("html-root")?.getBoundingClientRect().width * 9 / 16;
        this.baseService.sendHeightToOuterFrame(this.video.userVideo.hashPublic, height);
        this.disablePlayKeyEvent();
        return;
        // const liveStart = this.checkStartLive();
        // if(! liveStart){
        //   return;
        // }
      }

      this.player = new jwplayer("video-" + this.video.hash);

      if(this.video.autoplay){
        this.update(true);
      }
      else{
        this.update(false);
      }
    }, 200);
  }
  onLiveThumbnailImageLoad(img: HTMLImageElement){
    const height = document.getElementById("html-root")?.getBoundingClientRect().width * img.height / img.width;
    this.baseService.sendHeightToOuterFrame(this.video.userVideo.hashPublic, height);
  }

  checkStartLive(){
    // 現在時刻
    const currentTime = Math.floor((new Date()).getTime() / 1000);

    // 開始時刻からの差分
    const diffTimeFromStart = currentTime - this.video.userVideo.live.start;
    // console.log(diffTimeFromStart);

    // ライブ開始案内中
    if(diffTimeFromStart < 0){
      // ライブ開始案内表示

      if(this.liveStatus != "before-start"){
        this.liveStatus = "before-start";

        // viewがレンダリングされるのを待つ
        setTimeout(() => {
          const liveStartDescriptionElement = this.document.getElementById("liveStartDescription");
          this.addLinkClickEvent(liveStartDescriptionElement);
          this.baseService.sendHeightToOuterFrame(this.video.userVideo.hashPublic);
        }, 100);
      }

      if(! this.liveStartSubcription){
        this.liveStartSubcription = timer(0, 1000)
          .subscribe(() => {
            // console.log("complete");
            if(this.liveStatus != "before-start"){
              this.liveStartSubcription.unsubscribe();
              this.liveStartSubcription = null;
              return;
            }

            this.checkStartLive();
          });
      }
      return false;
    }
    // ライブ終了案内中
    else if(diffTimeFromStart >= Math.floor(this.video.userVideo.time)){
      // ライブ終了案内表示
      this.endLive();
      return false;
    }
    // ライブ中
    else{
      this.liveStatus = "live";
      this.startLive();
      return true;
    }
  }

  startLive(){
    this.liveStatus = "live";

    this.player = new jwplayer("video-" + this.video.hash);
    this.update(true);
  }

  endLive(){
    if(this.liveStatus != "after-end"){
      this.liveStatus = "after-end";
      setTimeout(() => {
        const liveEndDescriptionElement = this.document.getElementById("liveEndDescription");
        this.addLinkClickEvent(liveEndDescriptionElement);
        this.baseService.sendHeightToOuterFrame(this.video.userVideo.hashPublic);
      }, 100);
    }
  }

  addLinkClickEvent(targetWrapperElement){
    const aElements = targetWrapperElement.querySelectorAll("a");
    aElements.forEach((aElement) => {
      aElement.addEventListener("click", (event) => {this.linkClicked(event)});
    });
  }

  linkClicked(event){
    const link = event.target.getAttribute("href");
    const title = event.target.innerText;

    console.log("CtaUpdate linkClicked");

    // CTAクリックしたら送信
    if(window.onerollq){
      // Trackに送信
      let data = {
        playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
        userVideoHashPublic: this.video.userVideo.hashPublic,
        videoViewHash: this.videoViewHash ? this.videoViewHash : null,
        hash: null,
        title: title,
        url:link,
      };
      window.onerollq('CtaUpdate', data);
    }
  }

  update(withPlay = false) {

    // Playlistの場合、生成
    if(this.playlist.type == "playlist"){
      this.videoViewHash = this.generateRandomString(32);
    }

    // video tagが貼られている場合、生成
    if(this.isVideoTagAttached()){
      this.videoTagViewHash = this.generateRandomString(32);
    }

    this.duration = 0;
    this.history = [];
    this.prevPosition = 0.0;
    this.viewState = 0.0; // 0(min) -> 1(max),
    this.watchtimeTriggeredTimes = 0;
    this.watchtimeTriggerInterval = null;
    this.isPassed0Seconds = false;
    // this.isPassed1Seconds = false;
    // this.isPassed2Seconds = false;
    this.isPassed3Seconds = false;
    this.isPassed10Seconds = false;

    this.isPassed0Percent = false;
    this.isPassed2Percent = false;
    this.isPassed5Percent = false;
    this.isPassed10Percent = false;
    this.isPassed25Percent = false;
    this.isPassed50Percent = false;
    this.isPassed75Percent = false;
    this.isPassed95Percent = false;

    let setting:any = {
      width: "100%",
      abouttext:"1Roll Player",
      aboutlink:"https://www.1roll.jp",
      pipIcon: "disabled",
      repeat:false,
      playlist:[
        {
          sources: this.video.userVideo.sources,
          image: this.video.userVideo.thumbnailPath,
          tracks: this.video.userVideo.transcripts.map((transcript, index) => {
            return {
              kind: "captions",
              file: transcript.url,
              label: transcript.label,
              default: (index == 0) ? true : false,
            };
          }),
        },
      ]

    };

    if(this.responsible){
      setting.aspectratio = "16:9";
    }
    else{
      setting.height = "100%";
    }

    if(withPlay){
      setting.autostart = true;
    }

    this.player.setup(setting);

    this.player.on('ready', () => {
      this.onReady();
    });

    this.player.on('time', (data) => {
      this.onTime(data);
    });

    // 追って実装（シークしたときに、シーク先の前に質問項目があればそこに戻す）
    this.player.on('seek', (data) => {
      this.onSeek(data);
    });

    this.player.on('pause', (data) => {
      this.onPause(data);
    });

    this.player.on('complete', () => {
      const data = {
        duration: this.player.duration,
        position: this.player.duration,
      };
      this.onComplete(data);
    });

    this.player.on('beforePlay', (data) => {
      this.onBeforePlay();
    });
    this.player.on('playbackRateChanged', (data) => {
      this.onPlaybackRateChanged(data);
    });

    document.addEventListener('keydown', (event) => {
      if(this.isEnablePlayKeyEvent){
        return;
      }
      const arrowKeys = ['ArrowLeft', 'ArrowRight'];

      if (arrowKeys.includes(event.key)) {
        event.preventDefault(); // 矢印キーのデフォルト動作を無効化
        event.stopPropagation();
        console.log(`disalbed: ${event.key}`);
      }
    }, { capture: true });
  }

  trigger(triggers:Array<Trigger>){    
    if(this.player){
      this.pause();
      // 停止した場所がtriggerの位置と1秒以上ズレがあればtriggerの位置に戻す
      if(this.player.getPosition() - triggers[0].seconds > 1.0){
        this.seek(triggers[0].seconds);
        this.pause();
      }
    }    

    this.playerTriggered.emit(triggers);
  }

  play(){
    if(! this.player){
      return;
    }
    this.player.play();
  }

  pause(){
    if(! this.player){
      return;
    }
    this.player.pause();
  }

  seek(seconds){
    if(! this.player){
      return;
    }
    this.player.seek(seconds);
  }

  onReady(){

    this.baseService.sendHeightToOuterFrame(this.video.userVideo.hashPublic);

    let style = PlayerHelper.getPlayerCss(this.playlist.color, this.chapters.length > 0);
    style = "<style>" + style + "</style>";
    this.style = this.domSanitizer.bypassSecurityTrustHtml(style);

    // sliderを初期化
    this.duration = this.video.userVideo.time;
    this.playerContainer = this.player.getContainer();
    this.position = 0;

    this.playerHelper = new PlayerHelper(this.video.userVideo, this.player);

    this.playerHelper.initInfo(this.lp);


    // Live再生の場合
    if(this.video.userVideo.live){
      this.playerHelper.atacheCustomLiveSetting();
    }
    // 通常再生の場合
    else{
      this.playerHelper.initChapter(this.playlist.chapterMode);

      this.chapters = this.video.userVideo.chapters;
      if(this.chapters.length > 0){
        this.sliderChaptersElement = this.playerContainer.querySelector(".oneroll-slider-chapters");
        this.sliderChapterElements = this.sliderChaptersElement.querySelectorAll("ul li span.slider-chapter-progress");
      }

      window.addEventListener('message', (event) => {
        console.log('message', event);
        try{
          const data = JSON.parse(event.data);
          if(data.type != 'Seek' || !data.data){
            return;
          }
          this.seek(data.data.time);
        }
        catch(error){}
      });
    }

    if(window.parent !== window){
      // 埋め込まれている場合
      const postPlayerMessageInitValue = {
        type: "PlayerMessageInit",
      };
      window.parent.postMessage(JSON.stringify(postPlayerMessageInitValue), "*");
    }

    const postPlayerMessageInitValue = {
      type: "PlayerMessageInit",
    };
    window.parent.postMessage(JSON.stringify(postPlayerMessageInitValue), "*");

    // unload時のイベント
    window.addEventListener('beforeunload', () => {
      this.onWindowUnload();
    });

    this.otVideoLoad();
    this.gaVideoLoad();

    // 画面クリックで再生・停止
    // jwplayerのjw-mediaについているイベントはpinter-events: noneでキャンセルしてある。(jwplayer.scss参照)
    // キャンセルする理由はダブルクリックでフルスクリーン化されるのを防ぐため。（iphoneだけは、フルスクリーン状態からプログラムで解除することができず、アンケートが表示されないため）
    var playerContainer = this.player.getContainer();
    var playerWrapperContainer = playerContainer.querySelector('.jw-wrapper');
    var jwMediaCoverElement = document.createElement('div');
    jwMediaCoverElement.setAttribute('class', 'jw-media-cover');
    var jwMediaElement = playerContainer.querySelector('.jw-media');
    var jwControlElement = playerContainer.querySelector('.jw-controls');
    playerWrapperContainer.insertBefore(jwMediaCoverElement, jwMediaElement.previousElementSibling);

    const isTouchDevice = playerContainer.classList.contains("jw-flag-touch");
    if(isTouchDevice){
      let timeoutId = null;
      jwControlElement.addEventListener("click", (event) => {
        if(timeoutId){
          clearTimeout(timeoutId);
          timeoutId = null;
        }
      });
      jwMediaCoverElement.addEventListener("click", (event) => {
        switch(this.player.getState()){
          case "playing":
            if(playerContainer.classList.contains('jw-flag-user-inactive')){
              playerContainer.classList.remove('jw-flag-user-inactive');
              if(timeoutId){
                clearTimeout(timeoutId);
                timeoutId = null;
              }
              timeoutId = setTimeout(() => {
                playerContainer.classList.add('jw-flag-user-inactive');
              }, 3000);
            }
            else{
              playerContainer.classList.add('jw-flag-user-inactive');
            }
            break;
          case "paused":
          case "idle":
            // this.player.play();
            break;
        }
      });
    }
    else{
      jwMediaCoverElement.addEventListener("click", (event) => {
        switch(this.player.getState()){
          case "playing":
            this.player.pause();
            break;
          case "paused":
          case "idle":
            this.player.play();
            break;
        }
      });
    }

    // これを制御すれば良い
    // jwplayer.jw-state-paused .jw-display-icon-display



    if(this.platform.IOS && this.isIphone()){
      let classString = playerContainer.getAttribute('class');
      classString += " ios";
      // playerContainer.setAttribute('class', classString);
    }

    // iPhoneのフルスクリーンボタンを消す
    var oldFullScreenBtnElement = document.querySelector(".jw-icon-fullscreen:not(.jw-fullscreen-ima)");
    if(this.platform.IOS && this.isIphone()){
      // 動画の再生を強制的に止めるコンテント（アンケート、オーバーレイフォームなど）がある場合、iフルスクリーンボタンを隠す
      const hasContentFormOrQa = this.video.contentLists.find(contentList => {
        return contentList.contents.find(content => {
          return (content instanceof Question) || (content instanceof MessageSimple) || (content instanceof FormOverlay);
        });
      });
      if(hasContentFormOrQa){
        oldFullScreenBtnElement.classList.add("hide");
      }

      // Liveのときはフルスクリーンボタンを表示
      if(this.video.userVideo.live){
        oldFullScreenBtnElement.classList.remove("hide");
      }
    }

    oldFullScreenBtnElement.addEventListener("click", (event) => {
      if(document.fullscreenElement){
        this.playerHelper.exitFullscreen();
      }
      else{
        this.playerHelper.fullscreen((this.platform.IOS && this.isIphone()));
      }
      event.stopPropagation();
    }, true);


    // picture in pictureを無効にする
    var videoElement = this.playerContainer.querySelector("video") as HTMLVideoElement;
    // @ts-ignore
    videoElement.disablePictureInPicture = true;

    // 通常動画の場合、tパラメータがある場合、tの値に従い途中から再生する
    if(! this.video.userVideo.live){
      const startTime = this.route.snapshot.queryParams.t;
      if(startTime){
        this.player.seek(startTime);
      }
    }
  }

  onBeforePlay(){
    console.log("onBeforePlay");

    this.checkTrigger(this.player.getPosition());

    if(this.isTriggered){
      this.player.stop();
      return;
    }

    if(this.video.userVideo.live){
      const diffTimeFromStart = this.getLiveCurrentTime();

      // ライブ開始案内中
      if(diffTimeFromStart < 0){
        this.liveStatus = "before-start";
      }
      // ライブ終了案内中
      else if(diffTimeFromStart > this.video.userVideo.time){
        this.liveStatus = "after-end";
        this.player.stop();
      }
      // ライブ中
      else{
        this.liveStatus = "live";
        this.player.seek(diffTimeFromStart);
      }
    }
  }

  getHeight(){
    if(! this.video.userVideo.formExpand){
      return "100%";
    }
    else{
      return this.playerRootElement.getBoundingClientRect().width * 9 / 16 + "px";
    }
  }

  getLiveCurrentTime(){
    if(! this.video.userVideo.live){
      return null;
    }
    // 現在時刻
    const currentTime = Math.floor((new Date()).getTime() / 1000);

    // 開始時刻からの差分
    const diffTimeFromStart = currentTime - this.video.userVideo.live.start;
    return diffTimeFromStart;
  }

  onPause(data){
    // pause時にhistory送信
    this.otVideoUpdate();
  }

  onSeek(data){
    if(this.video.userVideo.live){
      const liveCurrentTime = this.getLiveCurrentTime();
      // seekがライブの正規時間から前後2秒以内のseekであれば正しい（この場合何もしない）
      if(liveCurrentTime - 2.0 <= data.offset && data.offset <= liveCurrentTime + 2.0){
        return;
      }
      // 2秒前後の範囲からズレているときは正規時間にseekし直す
      this.seek(liveCurrentTime);
      return;
    }

    // 初期化する。最大視聴位置を超えるまでtrackリクエストが発生しなくなるため
    this.viewState = 0.0;
    // シーク時にhistory送信
    this.otVideoUpdate();
    // 追って実装（シークしたときに、シーク先の前に質問項目があればそこに戻す）
  }

  onPlaybackRateChanged(data){
    // ライブ時は再生速度は変更不可
    if(this.video.userVideo.live){
      this.player.setPlaybackRate(1.0);
    }
  }

  onTime(data){
    this.position = data.position;

    // SliderChapterをupdate
    this.updateSliderChapter();

    // 初回（nullのとき）は必ず実行
    if(this.onTimeEventCounter !== null){
      this.onTimeEventCounter++;
      if(this.onTimeEventCounter % this.onTimeEventRate != 0){
        return;
      }
    }
    this.onTimeEventCounter = 0;

    // CTA表示
    this.updateCta();

    // 動画視聴ヒストリーをまとめる
    this.updateHistory();

    // 現在の位置を保存
    this.prevPosition = this.position;

    // ヒストリーをtrackに送信
    this.checkSeconds(data);

    // 最大再生位置に更新があれば更新
    if(this.maxPosition < this.position){
      this.maxPosition = this.position;
    }

    this.checkTrigger(this.position);
  }

  onComplete(data){
    if(this.video.userVideo.live){
      this.endLive();
    }
    this.checkSeconds(data);
    this.checkTrigger(this.duration);
  }

  onWindowUnload(){
    if(this.history && this.history.length > 0){
      this.otVideoUpdateEnd();
    }
  };

  checkTrigger(position){
    if(this.isTriggered){
      // トリガー発火中は以下の処理を行わない
      return;
    }

    let triggers:Array<Trigger>;

    // トリガー判定。条件を満たしているトリガーを収集する
    if(this.video.triggers){
      for(let trigger of this.video.triggers){
        if(! trigger.triggered && trigger.seconds <= position){
          if(! triggers){
            triggers = [];
          }
          triggers.push(trigger);
        }
      }
    }
    if(triggers && triggers.length > 0){
      // トリガーの並び替え
      triggers.sort(Trigger.compareSeconds);
    }

    // 動画の最後のトリガー
    if(this.video.trigger){
      if( position >= this.duration - 0.01){
        if(! triggers){
          triggers = [];
        }
        triggers.push(this.video.trigger);
      }
    }

    if(triggers){
      this.isTriggered = true;
      this.trigger(triggers);
    }
  }

  updateSliderChapter(){

    const position = this.player.getPosition();

    for(let i = 0; i < this.chapters.length; i++){

      let startTime = this.chapters[i].time;
      let endTime;
      if(i < this.chapters.length - 1){
        endTime = this.chapters[i + 1].time;
      }
      else{
        endTime = this.duration;
      }

      if(position < startTime){
        // width: 0%;
        this.sliderChapterElements[i].style.width = "0%";
        continue;
      }
      else if(startTime <= position && position < endTime){
        // width: xx%;
        this.sliderChapterElements[i].style.width = ((position - startTime) / (endTime - startTime) * 100) + "%";
      }
      else{
        // width: 10%;
        this.sliderChapterElements[i].style.width = "100%";
      }
    }
  }

  updateCta(){
    if(! this.video.userVideo.ctaSimple){
      return;
    }
    const ctaSimple = this.video.userVideo.ctaSimple;
    if(ctaSimple.showTiming === null){
      return;
    }
    if(ctaSimple.isShown){
      return;
    }

    const position = this.player.getPosition();
    if(position < ctaSimple.showTiming){
      return;
    }

    ctaSimple.isShown = true;

    // type: overlay, expandによりそれぞれ表示を実行する
    if(ctaSimple.showType == CtaShowType.overlay){
      this.playerHelper.enableCta();
      setTimeout(() => {
        this.playerHelper.showCta();
      }, 10);
    }
    else if(ctaSimple.showType == CtaShowType.expand){
      setTimeout(() => {
        this.baseService.sendHeightToOuterFrame(this.video.userVideo.hashPublic);
      }, 300);
    }
  }

  formExpandInputedEvent(formExpand: FormExpand){
    this.formExpandInputed.emit(formExpand);
  }



  //////////////////////////////////////////////////////////////////////////////
  // track計測用メソッド /////////////////////////////////////////////////////////

  checkSeconds(data){
    // 所定の時間経過後にそれぞれhistoryを送信する
    // 1. 最初の10秒間は0,3秒目に計測
    // 2. 60秒以上の動画は10秒目にも計測
    // 2. 実行間隔 = duration / (duration / 15 + 2) を経過時
  // 15秒: 0s, 3s, 5s, 10s, 15s
  // 30秒: 0s, 3s, 7.5s, 15s, 22.5s, 30s
  // 60秒: 0s, 3s, 10s, 20s, 30s, 40s, 50s, 60s
  // 120秒: 0s, 3s, 10s, 15s, 30s, 45s, 60s, 75s, 90s, 105s, 120s
  // 180秒: 0s, 3s, 10s, 16.4s, 32.7s, 49.1s, 65.5s, 81.8s, 98.2s, 114.5s, 130.9s, 147.3s, 163.6s, 180s
  // 300秒: 0s, 3s, 10s, 25s, 50s, 75s, 100s, 125s, 150s, 175s, 200s, 225s, 250s, 275s, 300s
  // 600秒: 0s, 3s, 10s, 42.9s, 85.7s, 128.6s, 171.4s, 214.3s, 257.1s, 300s, 342.9s, 385.7s, 428.6s, 471.4s, 514.3s, 557.1s, 600s
  // 1800秒: 0s, 3s, 10s, 105.9s, 211.8s, 317.6s, 423.5s, 529.4s, 635.3s, 741.2s, 847.1s, 952.9s, 1058.8s, 1164.7s, 1270.6s, 1376.5s, 1482.4s, 1588.2s, 1694.1s, 1800s
  // 3600秒: 0s, 3s, 10s, 150s, 300s, 450s, 600s, 750s, 900s, 1050s, 1200s, 1350s, 1500s, 1650s, 1800s, 1950s, 2100s, 2250s, 2400s, 2550s, 2700s, 2850s, 3000s, 3150s, 3300s, 3450s, 3600s

    if(! this.isPassed0Seconds && (0.0 <= data.position && data.position < 1.0)){
      this.isPassed0Seconds = true;
      this.otVideoUpdate();
      return;
    }
    // if(! this.isPassed1Seconds && (1.0 <= data.position && data.position < 2.0)){
    //   this.isPassed1Seconds = true;
    //   this.otVideoUpdate();
    //   return;
    // }
    // if(! this.isPassed2Seconds && (2.0 <= data.position && data.position < 3.0)){
    //   this.isPassed2Seconds = true;
    //   this.otVideoUpdate();
    //   return;
    // }
    if(! this.isPassed3Seconds && data.position >= 3.0){
      this.isPassed3Seconds = true;
      this.otVideoUpdate();
      return;
    }
    if(! this.isPassed10Seconds && data.position >= 10.0 && data.duration >= 60.0){
      this.isPassed10Seconds = true;
      this.otVideoUpdate();
      return;
    }

    const passedPercent = data.position / data.duration * 100;
    if(! this.isPassed0Percent && passedPercent >= 0){ this.isPassed0Percent = true; this.gaVideoUpdate(0); }
    if(! this.isPassed2Percent && passedPercent >= 2){ this.isPassed2Percent = true; this.gaVideoUpdate(2); }
    if(! this.isPassed5Percent && passedPercent >= 5){ this.isPassed5Percent = true; this.gaVideoUpdate(5); }
    if(! this.isPassed10Percent && passedPercent >= 10){ this.isPassed10Percent = true; this.gaVideoUpdate(10); }
    if(! this.isPassed25Percent && passedPercent >= 25){ this.isPassed25Percent = true; this.gaVideoUpdate(25); }
    if(! this.isPassed50Percent && passedPercent >= 50){ this.isPassed50Percent = true; this.gaVideoUpdate(50); }
    if(! this.isPassed75Percent && passedPercent >= 75){ this.isPassed75Percent = true; this.gaVideoUpdate(75); }
    if(! this.isPassed95Percent && passedPercent >= 95){ this.isPassed95Percent = true; this.gaVideoUpdate(95); }

    var currentViewState = data.position / data.duration;
    if(currentViewState <= this.viewState){
        return;
    }
    this.viewState = currentViewState;

    // 15秒が基準で3回から
    this.watchtimeTriggerInterval = data.duration / (Math.floor(data.duration / 15.0) + 2.0);

    // 前回のtrackリクエスト発生地点より視聴位置が前の場合は、カウンター(this.watchtimeTriggeredTimes)を視聴位置に合わせて更新する
    // これがないと最大視聴位置を超えるまでtrackリクエストが発生しなくなるため
    let preWatchtimeTriggerPosition = this.watchtimeTriggeredTimes * this.watchtimeTriggerInterval;
    if(data.position <= preWatchtimeTriggerPosition){
      this.watchtimeTriggeredTimes = Math.floor(data.position / this.watchtimeTriggerInterval);
      this.watchtimeTriggeredTimes--;
    }

    var watchtimeTriggerPosition = (this.watchtimeTriggeredTimes + 1) * this.watchtimeTriggerInterval;
    if(data.position < watchtimeTriggerPosition){
        return;
    }
    this.watchtimeTriggeredTimes = Math.floor(data.position / this.watchtimeTriggerInterval);
    this.otVideoUpdate();
  };

  updateHistory(){
    // ヒストリーを作る
    // historyオブジェクト: Array<{s:float, p:float, e:float}>
    // s:シーンのスタート位置、p:シーンの経過位置、e:シーンの終了位置
//      console.log(this.history);

    var position = this.player.getPosition();
    var lastHistory = this.history.slice(-1)[0];

    // まだhistoryが存在しない場合（再生直後）
    if(! lastHistory){
      var startPosition = position < 1 ? 0 : position; // 最初の値が1秒より小さい場合、0秒とみなす
      this.history.push({s: startPosition, p: startPosition});
      this.updateVideoTagUserVideoHistory();
      return;
    }

    // 一度再生が途切れている場合
    if(lastHistory.e){
      this.history.push({s: position, p: position}); // 新たなhistoryを入れる
      this.updateVideoTagUserVideoHistory();
      return;
    }

    // 再生を継続している場合
    if(Math.abs(position - this.prevPosition) < 3){ // lastHistoryと現在の位置の差が3秒以内の場合
      lastHistory.p = position;
      this.updateVideoTagUserVideoHistory();
      return;
    }

    // 再生が途切れて新たに始まったとみなす場合
    lastHistory.e = this.prevPosition;
    this.history.push({s: position, p: position});
    this.updateVideoTagUserVideoHistory();
  };

  updateVideoTagUserVideoHistory(){
    if(this.isVideoTagAttached()){
      for(const videoTagUserVideo of this.video.userVideo.videoTagUserVideos){
        videoTagUserVideo.generateHistory(this.videoTagViewHash, this.history);
      }
    }
  }

  otVideoLoad(){
    if(! window.onerollq){
      return;
    }
    var data = {
      playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
      userVideoHashPublic: this.video.userVideo.hashPublic,
      videoViewHash: this.videoViewHash ? this.videoViewHash : null,
      referrer: document.referrer
    };
    window.onerollq('VideoLoad', data);
  };
  otVideoUpdate(){
    if(! window.onerollq){
      return;
    }
    if(! this.duration || ! this.history){
      return;
    }
    if(this.history.length == 0){
      return;
    }

    var data = {
      play:{
        duration: this.duration,
        history: this.history,
      },
      playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
      userVideoHashPublic: this.video.userVideo.hashPublic,
      videoViewHash: this.videoViewHash ? this.videoViewHash : null,
      referrer: document.referrer,
      videoTagSectionViewData: null
    };
    if(this.isVideoTagAttached()){
      const dateFormat = (new Date()).toISOString();
      data.videoTagSectionViewData = {
        date: dateFormat,
        videoTagUserVideos: [],
      };
      for(const videoTagUserVideo of this.video.userVideo.videoTagUserVideos){
        if(videoTagUserVideo.history){
          data.videoTagSectionViewData.videoTagUserVideos.push(videoTagUserVideo.serialize());
        }
      }
    }
    window.onerollq('VideoUpdate', data);
  };
  otVideoUpdateEnd(){
    if(! window.onerollq){
      return;
    }
    if(! this.duration || ! this.history){
      return;
    }
    if(this.history.length == 0){
      return;
    }
    var data = {
      play:{
        duration: this.duration,
        history: this.history,
      },
      playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
      userVideoHashPublic: this.video.userVideo.hashPublic,
      videoViewHash: this.videoViewHash ? this.videoViewHash : null,
      referrer: document.referrer,
      videoTagSectionViewData: null
    };
    if(this.isVideoTagAttached()){
      const dateFormat = (new Date()).toISOString();
      data.videoTagSectionViewData = {
        date: dateFormat,
        videoTagUserVideos: [],
      };
      for(const videoTagUserVideo of this.video.userVideo.videoTagUserVideos){
        if(videoTagUserVideo.history){
          data.videoTagSectionViewData.videoTagUserVideos.push(videoTagUserVideo.serialize());
        }
      }
    }
    window.onerollq('VideoUpdateEnd', data);
  };

  gaVideoLoad(){
    if(! this.gaService.enable){
      return;
    }
    // console.log("gaVideoLoad");
    this.gaService.videoLoad({
      duration: this.duration,
      title: this.video.userVideo.title,
      videoId: this.video.userVideo.hashPublic,
    });
  }
  gaVideoUpdate(percent){
    if(! this.gaService.enable){
      return;
    }
    if(this.maxPosition >= this.position){
      return;
    }
    // console.log("gaVideoUpdate", this.maxPosition, this.duration, this.maxPosition / this.duration);
    this.gaService.videoProgress({
      currentTime: this.position,
      duration: this.duration,
      percent: percent,
      title: this.video.userVideo.title,
      videoId: this.video.userVideo.hashPublic,
    });
  }

  // END track計測用メソッド /////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  generateRandomString(length = 32){
    // 生成する文字列の長さ

    // 生成する文字列に含める文字セット
    var c = "abcdefghijklmnopqrstuvwxyz0123456789";

    var cl = c.length;
    var r = "";
    for(var i = 0; i < length; i++){
      r += c[Math.floor(Math.random()*cl)];
    }
    return r;
  }

  // getDateFormat(date): string{
  //   if(!(date instanceof Date)){
  //     throw new Error("param must be Date instance");
  //   }
  //   return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  // }

  isIphone(){
    return /iPhone/i.test(navigator.userAgent);
  }
    
  isVideoTagAttached(): boolean{
    return (this.video.userVideo.videoTagUserVideos && this.video.userVideo.videoTagUserVideos.length > 0) ? true : false;
  }

  enablePlayKeyEvent(){
    this.isEnablePlayKeyEvent = true;
    this.toggleMediaSession(true);
  }
  disablePlayKeyEvent(){
    this.isEnablePlayKeyEvent = false;
    this.toggleMediaSession(false);
  }

  toggleMediaSession(enable:boolean){
    if(enable){
      // @ts-ignore
      navigator.mediaSession.setActionHandler('play', () => {
        this.play();
      });
      // @ts-ignore
      navigator.mediaSession.setActionHandler('pause', () => {
        this.pause();
      });
      // @ts-ignore
      navigator.mediaSession.setActionHandler('seekforward', () => {
        const time = this.player?.currentTime ?? 0;
        this.seek(time + 5);
      });
      // @ts-ignore
      navigator.mediaSession.setActionHandler('seekbackward', () => {
        const time = this.player?.currentTime ?? 0;
        this.seek(time - 5);
      });
    }
    else{
      // @ts-ignore
      navigator.mediaSession.setActionHandler('play', () => {});
      // @ts-ignore
      navigator.mediaSession.setActionHandler('pause', () => {});
      // @ts-ignore
      navigator.mediaSession.setActionHandler('seekforward', () => {});
      // @ts-ignore
      navigator.mediaSession.setActionHandler('seekbackward', () => {});
    }
  }
}
